import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { ApresentacaoComponent } from './apresentacao.component';
import { SafeModule } from './../../shared/pipe/safe/safe.module';

@NgModule({
  declarations: [
    ApresentacaoComponent
  ],
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    LocalizeRouterModule,
    SafeModule
  ],
  exports: [
    ApresentacaoComponent
  ]
})

export class ApresentacaoModule { }
